import React from "react";
import Typography from "@material-ui/core/Typography";

export const ServerRules = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Server Rules</u>
      </Typography>
      <p>
        To help us achieve the core principles, we've instituted the following
        rules - please help us build a better place to play by following them!
      </p>
      <p>1) Membership of Combined Arms is a privilege, and not a right.</p>
      <p>2) Don’t be a dick.</p>
      <p>
        3) No recruiting - including posting discord links or recruitment links
        - even if it's a link to a non-arma3 discord.
      </p>
      <p>
        4) Treat others with respect, especially those you don’t know well. Make
        all guests & members welcome, especially those who are new to the
        community.
      </p>
      <p>
        5) We take a zero tolerance policy to any form of
        Racist/Homophobic/Derogatory language - it is not acceptable for use in
        any Combined Arms forum, even when used in a non-serious or "joking"
        manner. Additionally for clarity, the use of the term "trap" is a slur.
        Do not expect leniency from CA staff if you are using slurs.
      </p>
      <p>
        6) Political, religious, and similar discussions are to be kept in
        current-affairs - please keep them civil and respectful. CA is a diverse
        group, and everyone will have differing opinions on subjects. It’s fine
        to discuss these, just make sure to follow Rules 2 and 4.
      </p>
      <p>
        7) Personal attacks on any individuals or groups either inside or
        outside of CA will not be tolerated.
      </p>
      <p>8) Do not bait/convince any other person into breaking the rules. </p>
      <p>
        9) Green member tags "gatekeep" many of our discord channels. To get
        green tags you must attend 2 or more arma 3 events over more than one
        weekend. An officer or moderator will apply these tags once you meet the
        criteria. If you think you have been missed out, PM an officer.
      </p>
      <p>
        10) Under normal circumstances, members of the community will be subject
        to a "three strikes" warning policy for rule breaches before receiving a
        permanent ban. The moderation team reserves the right to bypass this
        guideline at their discretion for any reason, at any time.
      </p>
      <p>
        11) All disciplinary decisions are at the moderation team's discretion,
        and we reserve the right to ban anyone, for anything, at any time.
      </p>
      <p>12) You must be aged 18+ to play with CA. </p>
      <p>
        13) @Moderators are the members of CA's staff that make decisions on
        behalf of CA and run the organisation's schedule and infrastructure.
        @Officers are the members of CA's staff that manage the day-to-day jobs
        of the community like looking after new members and helping the
        community in any way they can. If you are new or need help, please ping
        @Officers in help and someone will come and assist you!
      </p>
      <p>
        14) We consider the base game & the apex and contact DLCs to be core
        content - if you do not own the apex and contact DLC packs then you may
        struggle to attend events as we no longer identify non-apex and
        non-contact events/slots. All other DLC is optional but as previous, may
        restrict your ability to play some slots & events.
      </p>
    </div>
  );
};

export default ServerRules;
